import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';

// CRA replaces this at build time, keeping the community bundle independent
// from camera management, sighting editing and the main dashboard.
const App = process.env.REACT_APP_APP_VARIANT === 'citizen-science'
  ? require('./community/CitizenScienceApp').default
  : process.env.REACT_APP_APP_VARIANT === 'community'
  ? require('./community/CommunityApp').default
  : require('./App').default;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
);
